import { render, staticRenderFns } from "./ModalNuevoReporte.vue?vue&type=template&id=01dfeb8a&scoped=true&"
import script from "./ModalNuevoReporte.vue?vue&type=script&lang=ts&"
export * from "./ModalNuevoReporte.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dfeb8a",
  null
  
)

export default component.exports